import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteFarm } from "services";

import { DELETE_FARM, GET_FARMS } from "consts";

export const useDeleteFarm = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [DELETE_FARM],
    mutationFn: deleteFarm,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_FARMS] });
    },
  });
};
